document.addEventListener('DOMContentLoaded', function () {

    if (typeof Swiper === 'undefined') return;
  
    document.querySelectorAll('.customer-stories__slider').forEach((slider) => {
  
      new Swiper(slider, {
        slidesPerView: 1.15,
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 700,
        loop: false,
        grabCursor: true,
        watchOverflow: true,
  
        pagination: {
          el: slider.querySelector('.customer-stories-pagination'),
          clickable: true
        },
  
        navigation: {
          nextEl: slider.querySelector('.customer-stories-next'),
          prevEl: slider.querySelector('.customer-stories-prev')
        },
  
        breakpoints: {
          768: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 14
          },
  
          1024: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 20
          }
        }
  
      });
  
    });
  
  });